import React from "react";

const AnimatedButton = ({
  onclickFun,
  icon,
  txt,
  btnCSS = "text-white bg-blue-600",
}) => {
  return (
    <button
      className={`
        group
        h-10
        mt-7
        rounded-sm
        flex
        items-center
        px-3
        gap-2
        overflow-hidden
        w-12
        hover:w-28
        transition-all
        duration-300
        ${btnCSS}
    `}
    onClick={onclickFun}
    >
      {icon}
      <span
        className="
            whitespace-nowrap
            translate-x-4
            opacity-0
            group-hover:translate-x-0
            group-hover:opacity-100
            transition-all
            duration-300
        "
      >
        {txt}
      </span>
    </button>
  );
};

export default AnimatedButton;
